export default __webpack_public_path__ + "static/media/bliav.b95edaa3.png";